import { useTranslation } from 'react-i18next'
import { formatTimestamp } from '@/shared/lib/time'

interface IntelBriefSummaryProps {
  brief: string
  generatedAt: string
  model: string
}

export function IntelBriefSummary({ brief, generatedAt, model }: IntelBriefSummaryProps) {
  const { t } = useTranslation('intel')

  if (!brief) {
    return (
      <div className="rounded-xl border border-border bg-card p-5 shadow-sm">
        <p className="text-sm text-muted-foreground">{t('brief.empty')}</p>
      </div>
    )
  }

  return (
    <div className="relative rounded-xl border border-border bg-card p-5 shadow-sm">
      <span className="absolute right-4 top-4 rounded-full bg-primary/10 px-2 py-0.5 text-xs font-semibold text-primary">
        {t('brief.aiBadge')}
      </span>
      <p className="pr-12 text-sm leading-relaxed text-foreground">{brief}</p>
      <p className="mt-3 text-xs text-muted-foreground">
        {t('brief.generatedBy', { model })} · {formatTimestamp(generatedAt)}
      </p>
    </div>
  )
}
